<template>
  <div v-if="totalPages > 1" class="pagination">
    <button
      class="page-btn page-nav"
      :disabled="currentPage <= 1"
      @click="goTo(currentPage - 1)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
    </button>

    <button
      v-for="p in visiblePages"
      :key="p"
      class="page-btn"
      :class="{ active: p === currentPage, ellipsis: p === '...' }"
      :disabled="p === '...'"
      @click="goTo(p)"
    >
      {{ p }}
    </button>

    <button
      class="page-btn page-nav"
      :disabled="currentPage >= totalPages"
      @click="goTo(currentPage + 1)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    currentPage: { type: Number, default: 1 },
    totalItems: { type: Number, default: 0 },
    pageSize: { type: Number, default: 12 }
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.totalItems / this.pageSize))
    },
    visiblePages() {
      const total = this.totalPages
      const current = this.currentPage
      if (total <= 7) {
        return Array.from({ length: total }, (_, i) => i + 1)
      }
      const pages = [1]
      if (current > 4) pages.push('...')
      const start = Math.max(2, current - 1)
      const end = Math.min(total - 1, current + 1)
      for (let i = start; i <= end; i++) pages.push(i)
      if (current < total - 3) pages.push('...')
      pages.push(total)
      return pages
    }
  },
  methods: {
    goTo(page) {
      if (page === '...' || page < 1 || page > this.totalPages || page === this.currentPage) return
      this.$emit('page-change', page)
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 24px 0 8px;
}

.page-btn {
  min-width: 34px;
  height: 34px;
  padding: 0 8px;
  border: 1px solid #e0e0e0;
  background: #fff;
  color: #555;
  font-size: 13px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover:not(:disabled):not(.ellipsis) {
    border-color: #b8934d;
    color: #b8934d;
  }

  &.active {
    background: #b8934d;
    border-color: #b8934d;
    color: #fff;
    font-weight: 600;
  }

  &.ellipsis {
    border: none;
    cursor: default;
    color: #aaa;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
}

.page-nav {
  padding: 0 10px;
}

@media (max-width: 768px) {
  .page-btn {
    min-width: 30px;
    height: 30px;
    font-size: 12px;
  }
}
</style>
